import React, { memo } from 'react'
import { withTranslation } from 'react-i18next'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import useStyles from './accordionDetailsStyle'
import Status from '../chat/Status'
import Tooltip from '../../atoms/display/tooltip'

const RenderAccordionDetails = ({history = null, conversation = null, historic = false, ...props}) => {

    const size = useSelector((state) => state.preferences)
    let useStylesParams = {
        size: size,
    }
    const { t } = useTranslation();
    const classes = useStyles(useStylesParams)
    const theme = useTheme()
    return (
      <div>
        <h1>{history?.name }</h1>
        <div className={classes.infoTicket} id="info" 
          style={{
            flexDirection: size === 'small' && 'column'
          }}>
          <div id="protocol" className={classes.infoContainer}
            style={{
              marginBottom: size === 'small' && '2em'
            }}
            >
            <span
              className={classes.inputTicket}
              style={{
                color:
                  theme.palette.type === 'dark'
                    ? theme.palette.primary.main
                    : '#172746',
              }}
            >
              {t('commons.protocol')}:{' '}
            </span>
            <Tooltip title={history?.protocol} placement="bottom">
              <span style={{
                  color: theme.palette.type == 'dark' ? 'white' : "#fff",
                  overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth:size === 'small' ? '75px' : '125px',
                      display: "inline-block"
              }}className={classes.labelTicket}>
                {history?.protocol}
              </span>
            </Tooltip>
          </div>
          
          {historic === false && !props?.invisibleSla && (
            <>
              <svg
              style={{ 
                marginRight: '10px',
                display: size === 'small' && 'none'
              }}
              width="5"
              height="40"
              viewBox="0 0 1 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="1" y1="20" x2="1" stroke="#009EE2" strokeOpacity="1" />
            </svg>
            <div id="SLA" className={classes.infoContainer}>
              <span
                className={classes.inputTicket}
                style={{
                  color:
                    theme.palette.type === 'dark'
                      ? theme.palette.primary.main
                      : '#172746',
                }}
              >
                SLA:{' '}
              </span>
              <div className={classes.labelTicket} style={{
                  padding: '0.28em',
                }}>
                <Status 
                  chatId={conversation?.conversationId} 
                  ticket
                  withSummary
                />
              </div>
            </div>
            </>
          )}
        </div>
      </div>
    )
  }

export default withTranslation()(memo (RenderAccordionDetails))